

export const baseURL= 
  "https://admin.houseofdhanushdhari.com/api/" 
 


export const auth={
   login: baseURL+"real-estate/login",
   register:baseURL+'real-estate/register',
   getProfile:baseURL+'real-estate/profile',
   logoutUser:baseURL+'real-estate/logout'
}


export const property={
   getProperty:baseURL+'real-estate-property',
   getGallery:baseURL+'real-estate/gallery',
   sendEnquiry:baseURL+'real-estate-property-enquiry',
   orderProperty:baseURL+'real-estate/create-order',
   verifyPayment:baseURL+'real-estate/verify-payment'
}

